export default "__VITE_ASSET__$Dmbufw4__"